export default __webpack_public_path__ + "static/media/acct-invoice.b6241d0b.png";